<h1 class="text-center">{{  textkeyPrefix + '.headline' | translate: welcomePlaceholder }}</h1>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-offset-2 medium-3 large-offset-2 large-3">
    <app-advisor-image path="/tec/tec-intro.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-5">
    <p [innerHTML]=" textkeyPrefix + '.teaser' | translate"></p>
  </div>
  <div class="cell small-12 medium-offset-1 medium-10">
    <div class="button-wrapper background">
      <div [innerHTML]=" textkeyPrefix + '.callout' | translate"></div>
      <button type="button" [routerLink]="nextLink" class="button primary inline-arrow-right">{{ textkeyPrefix + '.next' | translate}} </button>
    </div>
  </div>
</div>
